import React from "react";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import { PrimaryButton, SecondaryButton } from "@prestosports/commons-ui";
import { ALL, PLAYER_CATEGORIES, TEAM_STAT_TOGGLES } from "./quick-stats-data";

const LIMIT_VALUES = [0, 1, 2, 3, 4, 5, 6, ALL];

const QuickStatsOptions = ({
	options,
	onChange,
	onGenerate,
	onBack,
	disabled
}) => {
	const setLimit = (key, value) =>
		onChange({ ...options, limits: { ...options.limits, [key]: value } });
	const setTeamStat = (key, checked) =>
		onChange({ ...options, teamStats: { ...options.teamStats, [key]: checked } });

	return (
		<Box>
			<Typography variant="h6">Quick Stats</Typography>
			<Typography variant="subtitle2">Number of players to list</Typography>
			<Box mt={2}>
				<Grid container spacing={2}>
					{PLAYER_CATEGORIES.map(({ key, label }) => (
						<Grid item xs={6} sm={3} key={key}>
							<FormControl variant="outlined" fullWidth size="small">
								<InputLabel id={`quick-stats-${key}-label`}>{label}</InputLabel>
								<Select
									labelId={`quick-stats-${key}-label`}
									label={label}
									value={options.limits[key]}
									disabled={disabled}
									onChange={(e) => setLimit(key, e.target.value)}
								>
									{LIMIT_VALUES.map((value) => (
										<MenuItem key={value} value={value}>
											{value === ALL ? "Show all" : value}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
					))}
				</Grid>
			</Box>

			<Box mt={2}>
				<Typography variant="subtitle2">Team statistics</Typography>
				<Grid container>
					{TEAM_STAT_TOGGLES.map(({ key, label }) => (
						<Grid item xs={12} sm={6} key={key}>
							<FormControlLabel
								label={label}
								control={
									<Checkbox
										color="primary"
										size="small"
										disabled={disabled}
										checked={!!options.teamStats[key]}
										onChange={(e) => setTeamStat(key, e.target.checked)}
									/>
								}
							/>
						</Grid>
					))}
				</Grid>
			</Box>

			<Box mt={2} display="flex" justifyContent="flex-end" gridGap={8}>
				<SecondaryButton
					label="Back"
					size="medium"
					onClick={onBack}
					disabled={disabled}
				/>
				<PrimaryButton
					label="Generate"
					size="medium"
					onClick={onGenerate}
					disabled={disabled}
				/>
			</Box>
		</Box>
	);
};

export default QuickStatsOptions;
